import { z } from 'zod'
import type { Hex } from '../../types'
import { addressPrimitiveSchema, lowerHexSchema } from '../../types/primitive'
import type { ContractCreation } from '../types'
import type { BlockscoutClient } from './client'

type GetContractCreatorAddressHashAndCreationTransactionHashParameters = {
  client: BlockscoutClient
  contractaddresses: Hex[]
  headers?: Record<string, string>
}

const contractCreationSchema = z.object({
  contractAddress: addressPrimitiveSchema,
  contractCreator: addressPrimitiveSchema,
  txHash: lowerHexSchema,
})
const resultSchema = z.array(contractCreationSchema)

/** {@link https://docs.blockscout.com/developer-support/api/rpc-endpoints/contract#get-contract-creator-address-hash-and-creation-transaction-hash} */
export const getContractCreatorAddressHashAndCreationTransactionHash = async ({
  client,
  contractaddresses,
  headers,
}: GetContractCreatorAddressHashAndCreationTransactionHashParameters): Promise<
  ContractCreation[]
> => {
  const result = await client.get({
    path: '',
    query: {
      module: 'contract',
      action: 'getcontractcreation',
      contractaddresses: contractaddresses.join(','),
    },
    resultSchema,
    headers,
  })
  return result
}
